import { memo, useContext } from "react";
import NormalLogin from "./NormalLogin";
import MNC_LOGO from "assets/images/mc-logo.svg";
import KTB_LOGO from "assets/images/ktb-logo.svg";
import NextLogin from "./NextLogin";
import { LoginContext, LoginType } from "..";

const Credentials = () => {
  const { tabLoginType, gotoNormalLogin, gotoQrLoging } =
    useContext(LoginContext);

  return (
    <div className="content-signin">
      <div className="py-5 card-mnc-main">
        <div className="logo-login">
          <picture className="d-flex justify-content-center">
            <div className="px-3 py-2">
              <img src={KTB_LOGO} alt="ktb logo" />
            </div>
            <div className="border-right px-3 py-2">
              <img src={MNC_LOGO} alt="mnc logo" />
            </div>
          </picture>
        </div>
        <div className="tab-login-main">
          {tabLoginType === LoginType.NEXT ? (
            <NextLogin gotoNormalLogin={gotoNormalLogin} />
          ) : (
            <NormalLogin gotoQrLoging={gotoQrLoging} />
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(Credentials);
